import { BrandColors } from '../theme';

export const togglebuttonTokens = {
    root: {
        borderRadius: '20px',
        checkedBackground: 'pink',
        disabledBackground: 'gray',
        disabledBorderColor:'gray',
        fontWeight: 'normal',
        hoverColor: BrandColors.orange[600],
        checkedColor: BrandColors.green[700],
        disabledColor: BrandColors.surface[400],
        padding: '0.70rem 0.75rem',
        focusRing: {
            color: "red",
        }
    },
    content: {
        padding: '0.70rem 0.75rem',
        borderRadius: '20px',
    },
    colorScheme: {
        light: {
            root: {
                background: 'transparent',
            },
            content: {
                checkedBackground: BrandColors.surface[0]
            }
        },
        dark: {
            root: {
                 background: 'blue',
            }
        }
    }
};